module.exports = __webpack_public_path__ + "img/project-9.7213ff11.jpg";